<template>
  <div :key="position" class="survey">
    <Header />

    <div class="content">
      <Info v-if="questionType === QUESTION_TYPE.INFO" />
      <TextField
        v-else-if="questionType === QUESTION_TYPE.TEXTFIELD"
        @setValid="setValid"
      />
      <Closed
        v-else-if="questionType === QUESTION_TYPE.CLOSED"
        @setValid="setValid"
      />
      <Slider
        v-else-if="
          questionType === QUESTION_TYPE.SLIDER10 ||
          questionType === QUESTION_TYPE.SLIDER11
        "
        @setValid="setValid"
      />
      <Multi
        v-else-if="questionType === QUESTION_TYPE.MULTI"
        @setValid="setValid"
      />
      <Finished
        v-else-if="questionType === QUESTION_TYPE.FINISHED"
        @close="handleClose"
      />
      <Undefined v-else />
    </div>

    <Footer v-if="questionType !== QUESTION_TYPE.FINISHED" :isValid="isValid" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import Header from '../internals/Header'
import Footer from '../internals/Footer'
import Info from '../internals/questions/Info'
import Closed from '../internals/questions/Closed'
import TextField from '../internals/questions/TextField'
import Multi from '../internals/questions/Multi'
import Slider from '../internals/questions/Slider'
import Undefined from '../internals/questions/Undefined'
import Finished from '../internals/questions/Finished'
import { QUESTION_TYPE } from '../../utils/constants'

const { mapGetters } = createNamespacedHelpers('survey')

export default {
  name: 'Survey',
  components: {
    Header,
    Footer,
    Info,
    Closed,
    TextField,
    Multi,
    Slider,
    Undefined,
    Finished,
  },
  data() {
    return {
      isValid: false,
    }
  },
  created() {
    this.QUESTION_TYPE = QUESTION_TYPE
  },
  computed: {
    ...mapGetters(['position', 'questionType']),
  },
  methods: {
    setValid(value) {
      this.isValid = value
    },
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="postcss" scoped>
.survey {
  display: flex;
  flex-direction: column;
  height: 100%;
}

@media (max-width: 768px) {
  .content {
    font-size: 1rem;
    margin: 10px 0 10px;
  }
}

@media (min-width: 768px) {
  .content {
    font-size: 1.5rem;
    margin: 60px 0 10px;
  }
}
</style>
